import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'

import { attributesNames } from '../../../../constants'
// import { Logger, LoggerTypes } from '../../../../utils'
import { AttributeToolsHeader } from '../../AttributeToolsHeader'
import { AttributeVariableDialogCreate } from '../dialogs'
import { AttributeVariableCard } from '../AttributeVariableCard'

export const AttributeVariablePanel = ({
  variables,
  currentProject,
  currentScenario,
  terms,
  openDialog,
  setOpenDialog,
  onSearch,
  onAdd,
  onUpdate,
  onImport,
  onDelete,
  onCreate
}) => {
  // Logger.trace(LoggerTypes.CONTAINER, 'AttributeVariablePanel.render()', {
  //   currentProject,
  //   currentScenario,
  //   variables,
  //   terms
  // })

  const TAB_PANEL_HEIGHT = `${$(window).height() - 265}px`

  return (
    <div className="AttributeVariablePanel" style={{ overflow: 'hidden auto', height: TAB_PANEL_HEIGHT }}>
      <AttributeToolsHeader
        currentProject={currentProject}
        currentScenario={currentScenario}
        attributeName={attributesNames.VARIABLES}
        terms={terms}
        onSearch={onSearch}
        onAdd={onAdd}
        onImport={onImport}
      />
      <div className="attributes-list">
        {variables &&
          variables.map((variable, index) => (
            <AttributeVariableCard
              key={`variable-${index}`}
              variable={variable}
              currentProject={currentProject}
              currentScenario={currentScenario}
              actionDispatchDelete={onDelete}
              actionDispatchUpdate={onUpdate}
            />
          ))}
      </div>
      {openDialog && (
        <AttributeVariableDialogCreate
          currentProject={currentProject}
          currentScenario={currentScenario}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          actionCreateDispatch={onCreate}
        />
      )}
    </div>
  )
}

AttributeVariablePanel.displayName = 'AttributeVariablePanel'

AttributeVariablePanel.propTypes = {
  variables: PropTypes.array.isRequired,
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  terms: PropTypes.string.isRequired,
  onSearch: PropTypes.func,
  onAdd: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  onCreate: PropTypes.func,
  onImport: PropTypes.func
}

AttributeVariablePanel.defaultProps = {
  variables: [],
  currentProject: null,
  currentScenario: null,
  terms: '',
  openDialog: false,
  setOpenDialog: () => {},
  onSearch: null,
  onAdd: null,
  onUpdate: null,
  onDelete: null,
  onCreate: null,
  onImport: null
}
